import type { HostExperienceItem } from "@website/accommodation-ui/villa-host-experience-carousel/villa-host-experience-carousel.types";
import type { Feature } from "@website/accommodation-ui/villa-host-feature-focus-scroller/villa-host-feature-focus-scroller.types";
import type {
  VillaHostCity,
  VillaHostInfoItem,
  VillaHostStepItem
} from "@website/accommodation-ui/villa-host.types";
import type { FaqType } from "@website/widget/faq";
import acceptPic from "../../public/assets/accept.png";
import accept from "../../public/assets/accept.svg";
import assistant from "../../public/assets/assistant.png";
import calendar from "../../public/assets/calendar.png";
import elmi from "../../public/assets/elmi.png";
import ghorbani from "../../public/assets/ghorbani.png";
import guestPic from "../../public/assets/guest.png";
import guest from "../../public/assets/guest.svg";
import instant from "../../public/assets/instant.png";
import loginPic from "../../public/assets/login.png";
import login from "../../public/assets/login.svg";
import befores from "../../public/assets/loginbefore.png";
import reserve from "../../public/assets/reserve.png";
import sameunit from "../../public/assets/sameunit.png";
import sherafat from "../../public/assets/sherafat.png";
import support from "../../public/assets/support.png";
import unit from "../../public/assets/unit.png";
import yousefi from "../../public/assets/yousefi.png";

export const infoItems: Array<VillaHostInfoItem> = [
  {
    title: "کاربر فعال اسنپ",
    value: 40_000_000,
    icon: "people"
  },
  {
    title: "میزبان در تمام شهر‌ها",
    value: 10_000,
    icon: "home_work"
  }
];

export const features: Array<Feature> = [
  { title: "تسویه آنی در روز ورود", icon: instant.src },
  { title: "پشتیبانی ۲۴ ساعته", icon: support.src },
  { title: "مدیریت همزمان واحدها", icon: sameunit.src },
  { title: " تعریف و مدیریت دستیارها ", icon: assistant.src },
  { title: "تعریف جداگانه واحد و مجموعه", icon: unit.src },
  { title: "مدیریت رزروها", icon: reserve.src },
  { title: "تقویم هوشمند عرضه و تقاضا", icon: calendar.src }
];

export const steps: Array<VillaHostStepItem> = [
  {
    icon: loginPic.src,
    title: "ثبت نام",
    items: ["ثبت مشخصات اولیه اقامتگاه", "ارسال مدارک مالکیت و هویتی"],
    after: login.src,
    before: befores.src
  },
  {
    icon: acceptPic.src,
    title: "تکمیل و تایید اطلاعات",
    items: [
      "تکمیل سایر اطلاعات در صورت نیاز",
      "تایید اطلاعات توسط کارشناسان اسنپ تریپ"
    ],
    after: accept.src
  },
  {
    icon: guestPic.src,
    title: "ورود مهمان و کسب درآمد",
    items: [
      "دریافت سریع رزرو و کسب و درآمد",
      "قرار گرفتن در معرض دید میلیون ها کاربر اسنپ"
    ],
    after: guest.src
  }
];

export const cities: Array<VillaHostCity> = [
  { fa: "اصفهان", en: "esfahan" },
  { fa: "یزد", en: "yazd" },
  { fa: "شیراز", en: "shiraz" },
  { fa: "بوشهر", en: "boushehr" },
  { fa: "قشم", en: "qeshm" },
  { fa: "رشت", en: "rasht" },
  { fa: "تهران", en: "tehran" },
  { fa: "تبریز", en: "tabriz" }
];

export const faqs: FaqType["list"] = [
  {
    question: "مدارک مورد نیاز برای ثبت اقامتگاه در اسنپ تریپ چیست؟",
    answer:
      "برای ثبت اقامتگاه در اسنپ تریپ، بسته به اینکه صاحب ملک باشید یا اقامتگاه را اجاره کرده باشید، باید تصویر سند مالکیت، اجاره نامه، کارت ملی میزبان و مالک را بارگذاری کنید. علاوه بر این باید با شماره و کد ملی یکسان مراحل ثبت نام را پیش ببرید."
  },
  {
    question: "برای ثبت اقامتگاه هزینه ای دریافت می شود؟",
    answer: "خیر، همه مراحل ثبت اقامتگاه رایگان است."
  },
  {
    question: "پرداخت مبلغ رزروها چطور انجام می شود؟",
    answer:
      "تمام تسویه ها به صورت آنی و بدون تاخیر پس از ورود مهمان، با کسر کمیسیون اسنپ تریپ به شماره شبای میزبان انجام خواهد شد."
  },
  {
    question: "برای ثبت اقامتگاه به چه اطلاعاتی نیاز دارم؟",
    answer:
      "اطلاعات کلی اقامتگاه مثل آدرس، نوع اقامتگاه، ظرفیت، اتاق ها، امکانات، امکانات خواب، تصاویر واضح و باکیفیت و مدارک ملکی و هویتی برای ثبت نام کافی است. هرچه اطلاعات کامل تری وارد کنید، احتمال رزرو اقامتگاه خود را افزایش می دهید."
  },
  {
    question: "اقامتگاه من چطور رزرو می شود؟",
    answer:
      "مهمانان با انتخاب اقامتگاه، درخواست رزرو را ارسال میکنند. میزبان می تواند در پنل میزبان رزرو را تایید یا رد کند. شما می توانید اقامتگاه خود را «آنی» کنید تا بدون نیاز به رد یا تایید رزرو، مهمانان پرداخت خود را نهایی کنند و شانس رزرو موفق را افزایش دهید."
  }
];

export const testimonials: Array<HostExperienceItem> = [
  {
    title: "تجربه میزبانی در اسنپ‌تریپ",
    quote:
      "من زمان زیادی برای مدیریت رزرو آپارتمانم نداشتم و فقط می‌خواستم راحت اجاره‌اش بدهم و از درآمدم مطمئن باشم. الان خیلی ساده می‌توانم رزروها، زمان‌های خالی و قیمت‌گذاری را مدیریت کنم و حتی وقتی سرم شلوغ است، همه‌چیز تحت کنترل هست. این سادگی کار برای من خیلی ارزش دارد.",
    name: "خانم قربانی",
    role: "میزبان اقامتگاه در رامسر",
    pic: ghorbani.src
  },
  {
    title: "تجربه میزبانی در اسنپ‌تریپ",
    quote:
      "برای من مهم‌ترین چیز این بود که پولم سریع به دستم برسه. با تسویه آنی و بدون تاخیر خیالم راحت‌تره. رزروها که ثبت می‌شن، بقیه مسیر دیگه نگرانی نداره. همین باعث شده با تمرکز بیشتری روی بهبود اقامتگاه‌هام کار کنم، نه پیگیری پرداخت‌ها.",
    name: "خانم شرافت",
    role: "میزبان اقامتگاه در شیراز",
    pic: sherafat.src
  },
  {
    title: "تجربه میزبانی در اسنپ‌تریپ",
    quote:
      "برای منی که چندتا کار هم‌زمان دارم، خیلی مهم بود بتوانم بخشی از کارها را بسپارم به یک نفر. الان با دستیار، هم کمک دارم هم خیالم راحته چون فقط به چیزهایی دسترسی دارد که خودم مشخص کردم. همین باعث شده کمتر درگیر جزئیات باشم و بیشتر روی مهمان‌ها تمرکز کنم.",
    name: "آقای علمی",
    role: "میزبان اقامتگاه در مشهد",
    pic: elmi.src
  },
  {
    title: "تجربه میزبانی در اسنپ‌تریپ",
    quote:
      "من چند ویلا و یک مجموعه کوچک دارم و همیشه مدیریت هم‌زمانشان سخت بود. در پنل میزبان اسنپ‌تریپ همه را یک‌جا ثبت کرده‌ام و می‌توانم واحدهای مجموعه را هم‌زمان مدیریت و قیمت‌گذاری کنم. الان خیلی راحت‌تر می‌بینم هر واحد چه زمانی رزرو شده و کارم خیلی ساده‌تر شده.",
    name: "آقای یوسفی",
    role: "میزبان اقامتگاه در تهران",
    pic: yousefi.src
  }
];
